import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';


export const promoteDetaillList = (routeId,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/findPromotionDetail/${routeId}?`+params,
        method: 'GET'
    })
}















// export const findProjectProgress = (params) => {
//     params = parseParam(params)
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/project_plan?` + params,
//         method: 'GET'
//     })
// }
// export const findClassifySelect = () => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/project_plan/select`,
//         method: 'GET'
//     })
// }
// export const addSystemClassify = (params) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/project_plan`,
//         method: 'POST',
//         data: params
//     })
// }
// export const editSystemClassify = (params) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/project_plan`,
//         method: 'PUT',
//         data: params
//     })
// }
// export const delSystemClassify = (id) => {
//     return request({
//         url: `${baseUrl}/joins-sales-cloud/v1/project_plan/${id}`,
//         method: 'DELETE',
//     })
// }